import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index')
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/register/index')
    },
    {
      path: '/chooseplatform',
      name: 'chooseplatform',
      component: () => import('@/views/chooseplatform/index')
    },
    {
      path: '/submitreview',
      name: 'submitreview',
      component: () => import('@/views/submitreview/index')
    },
    {
      path: '/waitingreview',
      name: 'waitingreview',
      component: () => import('@/views/waitingreview/index')
    },
    {
      path: '/personalinfo',
      name: 'personalinfo',
      component: () => import('@/views/personalinfo/index')
    },
    {
      path: '/iframepagestation',
      name: 'iframepagestation',
      component: () => import('@/views/iframepagestation/index')
    },
    {
      path: '/',
      name: 'Layout',
      redirect: '/iframepageyingyong',
      component: Layout,
      children: [
        {
          path: '/iframepageyingyong',
          name: 'iframepageyingyong',
          component: () => import('@/views/iframepageyingyong/index')
        },
        {
          path: '/iframepagechanpin',
          name: 'iframepagechanpin',
          component: () => import('@/views/iframepagechanpin/index')
        },
        {
          path: '/iframepagefuwu',
          name: 'iframepagefuwu',
          component: () => import('@/views/iframepagefuwu/index')
        },
        {
          path: '/ai',
          name: 'ai',
          component: () => import('@/views/ai/index')
        },
        {
          path: '/personalcenter',
          name: 'personalcenter',
          component: () => import('@/views/personalcenter/index')
        }
      ]
    },
    { path: '/404', component: () => import('@/views/404') },
    { path: '*', redirect: '/404' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js